var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveBanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9277 12.5714H25.0706V17.7143H23.9277V12.5714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9573 8.00688C19.9483 8.00226 19.9383 7.99995 19.9281 8.00001C19.9179 7.99982 19.9079 8.00238 19.899 8.00745L13.6533 11.4131L26.1739 11.4286L19.9573 8.00688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6426 12.5714H22.7855V17.7143H21.6426V12.5714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43208 1.71431H16.4241C16.6248 1.71412 16.8106 1.60875 16.9138 1.43662L17.7761 0H6.08008L6.94239 1.43656C7.04552 1.60869 7.23139 1.71412 7.43208 1.71431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5619 27.3143C12.2109 27.5482 11.7596 27.5697 11.3879 27.3703C11.0162 27.1709 10.7846 26.7829 10.7853 26.3612V24.5715H10.2139C8.95149 24.5715 7.92818 23.5481 7.92818 22.2858V6.85712C7.92818 5.59475 8.95155 4.57144 10.2139 4.57144H21.6424V2.28569C21.6424 1.02337 20.6191 0 19.3567 0H19.1087L17.8938 2.02513C17.5827 2.53994 17.0256 2.85531 16.4241 2.85713H7.43212C6.83055 2.85531 6.27355 2.53994 5.96243 2.02513L4.74755 0H4.49955C3.23718 0 2.21387 1.02337 2.21387 2.28569V29.7143C2.21387 30.9766 3.23718 32 4.49955 32H19.3567C20.6191 32 21.6424 30.9766 21.6424 29.7143V24.5714H16.6709L12.5619 27.3143ZM18.7852 29.7143C18.7852 30.0299 18.5294 30.2857 18.2138 30.2857H5.64243C5.32687 30.2857 5.07099 30.0299 5.07099 29.7143C5.07099 29.3987 5.3268 29.1429 5.64243 29.1429H18.2139C18.5294 29.1429 18.7852 29.3987 18.7852 29.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6427 5.71432H10.2142C9.58298 5.71432 9.07129 6.22601 9.07129 6.8572V22.2858C9.07129 22.917 9.58298 23.4286 10.2142 23.4286H11.357C11.6726 23.4286 11.9285 23.6845 11.9285 24.0001V26.3612L16.1828 23.5246C16.2767 23.462 16.387 23.4286 16.4999 23.4286H29.6428C30.274 23.4286 30.7857 22.917 30.7857 22.2858V6.85714C30.7855 6.22595 30.2739 5.71432 29.6427 5.71432ZM27.357 20.5715C27.357 21.2026 26.8453 21.7143 26.2141 21.7143H13.6427C13.0115 21.7143 12.4999 21.2026 12.4999 20.5715V18.8571C12.4999 18.2259 13.0115 17.7143 13.6427 17.7143V12.568C13.1186 12.5613 12.6644 12.2034 12.5353 11.6954C12.404 11.1863 12.6408 10.6538 13.1067 10.4103L19.3518 7.00339C19.7117 6.80995 20.1446 6.80995 20.5044 7.00339L26.7507 10.4103C27.2169 10.6537 27.4537 11.1863 27.3222 11.6954C27.1934 12.2038 26.7386 12.562 26.2142 12.568V17.7143C26.8453 17.7143 27.357 18.2259 27.357 18.8571V20.5715H27.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3564 18.8571H21.0707H18.785H16.4993H14.2136H13.6422H13.6416L13.6422 20.5714H26.2136V18.8571H25.6422H23.3564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7852 12.5714H15.928V17.7143H14.7852V12.5714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3564 12.5714H20.4993V17.7143H19.3564V12.5714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0713 12.5714H18.2142V17.7143H17.0713V12.5714Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_2450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBanking);
export default __webpack_public_path__ + "static/media/activeBanking.cec1a3b7cdcb61e39f4590ec5d5593a0.svg";
export { ForwardRef as ReactComponent };